var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9321 -8250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9321 8250)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15803.869 6629.617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6497.864,1807.627h-5.845a1.034,1.034,0,0,1-1.149-1.177,5.4,5.4,0,0,1,4.1-5.105,6.754,6.754,0,0,1,1.4-.166c1-.024,2-.009,3-.007a5.383,5.383,0,0,1,5.272,3.983,6.171,6.171,0,0,1,.2,1.342,1.017,1.017,0,0,1-1.109,1.13h-5.873Zm5.5-1.478c-.049-.233-.086-.439-.137-.641a3.889,3.889,0,0,0-3.487-2.851c-1.213-.025-2.428-.032-3.641,0a3.706,3.706,0,0,0-3.327,2.1,3.173,3.173,0,0,0-.4,1.391Z",
    transform: "translate(0 -161.274)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6692.813,1655.385a3.5,3.5,0,0,1-2.242-.767c-.2-.157-.236-.277-.085-.5a4.735,4.735,0,0,0,.819-2.724,4.339,4.339,0,0,0-.456-1.985c-.12-.234-.063-.349.152-.481a3.481,3.481,0,1,1,2.366,6.416A5.069,5.069,0,0,1,6692.813,1655.385Z",
    transform: "translate(-188.416 -17.043)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6548.955,1638.335a3.976,3.976,0,1,1,3.971-4.15A3.911,3.911,0,0,1,6548.955,1638.335Zm-.009-1.457a2.513,2.513,0,1,0-2.522-2.52A2.481,2.481,0,0,0,6548.946,1636.878Z",
    transform: "translate(-51.094 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6721.462,1810.168a3.125,3.125,0,0,1,.318-.027c.8.014,1.6-.009,2.387.059a4.653,4.653,0,0,1,2.711,1.159,4.989,4.989,0,0,1,1.737,3.626,1.021,1.021,0,0,1-1.043,1.127c-1.353-.026-2.706,0-4.059,0a.186.186,0,0,1-.062-.017,5.5,5.5,0,0,0,.2-.987,6.172,6.172,0,0,0-2-4.686c-.053-.051-.106-.1-.156-.156C6721.482,1810.254,6721.482,1810.232,6721.462,1810.168Z",
    transform: "translate(-217.756 -169.751)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanHead);
export default __webpack_public_path__ + "static/media/icon-planHead.c248dc5a.svg";
export { ForwardRef as ReactComponent };